// @flow

const PREV_ROUTER_KEY = 'prev_router';

export const getPrevPath = (): ?string => localStorage.getItem(PREV_ROUTER_KEY);

export const setPrevPath = (path: string): void => localStorage.setItem(PREV_ROUTER_KEY, path);

export const removePrevPath = (): void => localStorage.removeItem(PREV_ROUTER_KEY);

export default (): void => {
  const path = getPrevPath();
  removePrevPath();
  if (path && path !== '/') window.location.pathname = path;
};
